
/**
 * A category. (tlc.ls2kids.model.Category)
 *
 * @constructor
 */
export class KidsCategory {
    constructor() { }
}

/** @type {string|null} */
KidsCategory.prototype.guid = null;

/** @type {number} */
KidsCategory.prototype.id = 0;

/** @type {string|null} */
KidsCategory.prototype.name = null;